import cn from 'classnames';
import { RadioProps } from './radio.props';
import styles from './radio.module.scss';

export const Radio = ({ className, ...rest }: RadioProps): JSX.Element => {
  const moduleStyles = cn(styles.module, className);

  return <input className={moduleStyles} type="radio" {...rest} />;
};
